export default "__VITE_ASSET__be4ca5f1__"